import methods from "../Service";
const FundService = {

    async Get() {  return await methods.Get("Fund/Get" ); },
    
};

export default FundService;